import { render } from "./PermissionGroupsManagement.vue?vue&type=template&id=90200022"
import script from "./PermissionGroupsManagement.vue?vue&type=script&lang=js"
export * from "./PermissionGroupsManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__